import { jsx as _jsx } from "react/jsx-runtime";
import { getEstados } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    { field: 'sigla', headerName: 'Sigla', width: 200 },
    { field: 'codigo_ibge', headerName: 'Código IBGE', width: 200 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function Estados() {
    return _jsx(GridBase, { pagina: PAGINAS.ESTADOS, paginaPermissao: FUNCIONALIDADES.ESTADOS, rota: ROUTES.ESTADOS, fetchData: function (str, _, pag) { return getEstados(str, pag); }, columns: COLUNAS });
}
